import * as React from 'react'
import { FC, memo } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import AddButton from '@organisms/AddButton'
import { DEFAULT_OPTIONS } from '@modals/RiskMapModal/getDefaultValues'
import { memoEqual } from '@utils/memo'
import { useAppDispatch } from '@hooks/useAppDispatch'
import {
  updateSelectedMeresForms,
  updateSelectedProtectionMeansForms,
} from '@services/riskMapModal'
import { MereFormItem } from './DangersFieldsBlock/DangersFieldsMeresModalButton/MeresFields'
import { ProtectionMeanItem } from './DangersFieldsBlock/DangersFieldsProtectionMeansModalButton/ProtectionMeansFields'
import { AddButtonWrapper, Container } from './styled'
import DangersFieldsBlock from './DangersFieldsBlock'

const DangersFields: FC = () => {
  const dispatch = useAppDispatch()

  const { control } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    name: 'dangerDTOs',
    control,
  })

  const handleAddNewForms = (index: number) => {
    dispatch(
      updateSelectedMeresForms({
        index,
        value: {
          prefilled: false,
          notAutoAddControlMeasures: false,
          meres: [{} as MereFormItem],
        },
      })
    )
    dispatch(
      updateSelectedProtectionMeansForms({
        index,
        value: {
          prefilled: false,
          notAutoAddProtectionMeans: false,
          protectionMeans: [{} as ProtectionMeanItem],
        },
      })
    )
  }

  const handleAdd = () => {
    handleAddNewForms(fields.length)
    append(DEFAULT_OPTIONS)
  }

  return (
    <Container>
      {fields.map((field, index, array) => (
        <>
          {window.ENABLE_LOGS && <h1>{index + 1}</h1>}
          <DangersFieldsBlock
            key={field.id}
            index={index}
            id={field.id}
            remove={remove}
            isLast={index === array.length - 1}
          />
        </>
      ))}
      <AddButtonWrapper>
        <AddButton id="risk-map-danger-add" onClick={handleAdd}>
          Добавить опасность
        </AddButton>
      </AddButtonWrapper>
    </Container>
  )
}

export default memo(DangersFields, memoEqual)
